// extracted by mini-css-extract-plugin
export default {"block":"AddPostButton_block__Y2xF+","userImage":"AddPostButton_userImage__MeUlA","addPostButton":"AddPostButton_addPostButton__H4RAi","camera":"AddPostButton_camera__hxyHw"};